/*
 * The guarded /catalogue route: the same deep-link protection every placeholder section gets
 * (section-access.ts), fronting the real CatalogueScreen instead of the generic placeholder.
 */
import { Navigate } from 'react-router-dom';
import { NoAccessScreen } from '../shell/NoAccessScreen';
import { useSectionAccess } from '../shell/section-access';
import { CatalogueScreen } from './CatalogueScreen';

export function CatalogueRoute() {
  const access = useSectionAccess('catalogue');

  if (access.kind === 'dead-end') {
    return <NoAccessScreen />;
  }
  if (access.kind === 'redirect') {
    return <Navigate to={access.to} replace />;
  }
  return <CatalogueScreen />;
}
